import { Cookie } from "lucide-react";
import { useEffect, useState } from "react";

export const CookieBanner = () => {
  const [ok, setOk] = useState(() => localStorage.getItem("fr_cookie_ok"));
  if (ok) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[70] bg-fr-navy text-white p-3 text-[11px] flex flex-wrap items-center gap-2" data-testid="cookie-banner">
      <Cookie size={14} className="text-amber-300" />
      <span className="flex-1 min-w-[200px]">Usiamo cookie tecnici e, con il tuo consenso, di misurazione. Informativa cookie: <a href="/legal" className="underline" data-testid="cookie-banner-link">pagine legali</a>.</span>
      <button onClick={() => { localStorage.setItem("fr_cookie_ok", "1"); setOk("1"); }} className="rounded-lg bg-white text-fr-navy font-bold px-3 py-1.5" data-testid="cookie-banner-accept">Accetto</button>
    </div>
  );
};

export default function LegalPage() {
  const lang = (typeof window !== "undefined" && window.localStorage.getItem("fr_lang")) || "it";
  const [content, setContent] = useState(null);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`).then((r) => r.json()).then(setContent).catch(() => setContent({}));
  }, []);
  const empty = (v) => !v || !v.trim();
  const fallback = "In aggiornamento – contattaci: 081 18351540 • 350 9656394";
  const terms = content ? (lang === "en" ? content.rental_terms_en : content.rental_terms_it) : "";
  const privacy = content ? (lang === "en" ? content.privacy_en : content.privacy_it) : "";
  return (
    <div className="min-h-screen bg-white" data-testid="legal-page">
      <header className="bg-fr-navy text-white h-14 flex items-center px-4">
        <a href="/" className="font-extrabold">← FabriRent Napoli</a>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8 space-y-8 text-sm text-gray-700 leading-relaxed">
        <section data-testid="legal-terms">
          <h1 className="text-xl font-extrabold text-fr-navy">{lang === "en" ? "Rental terms and conditions" : "Condizioni generali di noleggio"}</h1>
          {empty(terms) ? (
            <p className="mt-2 bg-amber-50 border border-amber-200 rounded-lg p-3 text-[11px] text-amber-800">In aggiornamento – contattaci</p>
          ) : (
            <div className="mt-2 whitespace-pre-wrap">{terms}</div>
          )}
        </section>
        <section data-testid="legal-privacy">
          <h2 className="text-lg font-extrabold text-fr-navy">{lang === "en" ? "Privacy notice" : "Informativa privacy"}</h2>
          {empty(privacy) ? (
            <p className="mt-2 bg-amber-50 border border-amber-200 rounded-lg p-3 text-[11px] text-amber-800">In aggiornamento – contattaci</p>
          ) : (
            <div className="mt-2 whitespace-pre-wrap">{privacy}</div>
          )}
        </section>
        <section data-testid="legal-company">
          <h2 className="text-lg font-extrabold text-fr-navy">Dati societari</h2>
          <p className="mt-2">FABRI RENT MULTISERVICE SRLS — P.IVA 03859111209<br />
            Sede legale: Via Selice 22, 40026 Imola (BO) • Sede operativa: Via Privata detta Sacra 33, 80145 Napoli<br />
            Lun–Sab 9:30–20:00, domenica chiuso • Tel 081 18351540 • 350 9656394 • 339 2662954<br />
            PEC: fabrirentmultiservice@pec.it</p>
        </section>
        <section data-testid="legal-review">
          <h2 className="text-lg font-extrabold text-fr-navy">Recensioni</h2>
          <p className="mt-2"><a className="underline text-fr-navy" href="https://g.page/r/CQfcf92RQ92nEBM/review" target="_blank" rel="noreferrer">Lascia una recensione su Google</a></p>
        </section>
        <p className="text-[10px] text-gray-400">{fallback}</p>
      </main>
    </div>
  );
}
